import React, {useRef, useState} from 'react';
import {diffWords} from "diff";
import Card from "../card";
import Modal from "../modal";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Button from "../button";
import TextCorrectionService from "../../services/text-correction";
const BASENAME = process.env.PUBLIC_URL;

const ReviseTextButton = ({value, setValue, setIsLoading, editor, module, url, disable = false}) => {
    const MySwal = withReactContent(Swal);

    const [open, setOpen] = useState(false);

    const [textCorrection, setTextCorrection] = useState("")
    const [textDiff, setTextDiff] = useState(undefined);

    const card1Ref = useRef(null);
    const card2Ref = useRef(null);
    const isSyncing = useRef(false);

    const onClick = () => {
        if (!value || !value.length) {
            MySwal.fire({
                icon: "error",
                title: "",
                showCancelButton: false,
                text: "Insira um texto",
                confirmButtonText: "Ok",
                confirmButtonColor: '#063A6C',
                reverseButtons: true
            })
            return;
        }

        if (setIsLoading) setIsLoading(true);
        const formData = new FormData();
        formData.append("input", value)
        formData.append("module", module)
        formData.append("url", url)
        formData.append('_method', 'POST');

        TextCorrectionService.correction(formData, {timeout: 120000})
            .then(({data}) => {
                setOpen(true);

                setTextCorrection(data.corrected_text);
                setTextDiff(diffWords(value, data.corrected_text));
            })
            .catch(error => {
                console.error(error);

                let message = 'Ocorreu um erro na requisição.';
                if (error.response?.status !== 500) {
                    switch (error.response?.data?.message) {
                        case "characters.not.exceeded": message = "O texto deve ter no mínimo 20 caracteres."; break;
                        default: message = 'Ocorreu um erro na requisição.';
                    }
                }

                MySwal.fire({
                    icon: "error",
                    title: "",
                    showCancelButton: false,
                    text: message,
                    confirmButtonText: "Ok",
                    confirmButtonColor: '#063A6C',
                    reverseButtons: true
                })
            })
            .finally(() => setIsLoading(false));
    }

    const correct = () => {
        if (editor) editor.commands.setContent(textCorrection)
        setValue(textCorrection);
        setOpen(false);
    }

    const syncScroll = (sourceRef, targetRef) => {
        if (!sourceRef.current || !targetRef.current || isSyncing.current) return;

        isSyncing.current = true;
        targetRef.current.scrollTop = sourceRef.current.scrollTop;

        window.requestAnimationFrame(() => {
            isSyncing.current = false;
        });
    };

    return (
        <>
            {
             !disable &&
                <Button onClick={onClick}>
                    <img className="h-4 w-4 shrink-0 object-contain" src={`${BASENAME}/img/improve_text.svg`} alt="" /> Melhorar e corrigir o texto
                </Button>
            }

            <Modal isOpen={open} isCloseClick={false} onClose={() => setOpen(false)} title={"Melhorar e corrigir o texto"} className={"w-8/12"} >
                <div className={"grid grid-cols-2 gap-3 !p-3"}>
                    <Card title={<b>Original</b>} bodyClass={"overflow-auto h-[35vh]"} ref={card1Ref} onScroll={() => syncScroll(card1Ref, card2Ref)}>
                        {textDiff?.filter(item => !item?.added).map((item, index) => {
                            if (editor) {
                                return (
                                    <span
                                        key={"text-" + index}
                                        style={item?.removed ? { color: "salmon" } : {}}
                                        dangerouslySetInnerHTML={{ __html: item.value }}
                                    />
                                );
                            }

                            return item?.removed ? (<span key={"text-" + index} style={{ color: "salmon" }}>{item.value}</span>) : (item.value);
                        })}
                    </Card>
                    <Card title={<b>Corrigido</b>} className={"overflow-auto h-[35vh]"} ref={card2Ref} onScroll={() => syncScroll(card2Ref, card1Ref)}>
                        {textDiff?.filter(item => !item?.removed).map((item, index) => {
                            if (editor) {
                                return (
                                    <span
                                        key={"text-" + index}
                                        style={item?.added ? { color: "forestgreen" } : {}}
                                        dangerouslySetInnerHTML={{ __html: item.value }}
                                    />
                                );
                            }

                            return item?.added ? (<span key={"text-" + index} style={{ color: "forestgreen" }}>{item.value}</span>) : (item.value);
                        })}
                    </Card>
                </div>
                <div className="flex justify-end gap-2 px-3 py-3 border-t border-gray-300 bg-[#F2F2F2] rounded-b-lg">
                    <div className="flex justify-end gap-3">
                        <Button target="primary" onClick={() => correct()}>
                            Corrigir
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ReviseTextButton;
